import Vue from 'vue';
import * as types from '../../mutationTypes';

export default {
    /* eslint-disable no-param-reassign */
    [types.RESET_NAVIGATION](state) {
        state.navigation = {};
        state.pageNameMap = {};
        state.fileNameMap = {};
        state.currentPage = '';
    },

    [types.SET_NAVIGATION](state, tocs) {
        tocs.forEach((data, index) => {
            const navigation = {};
            const moduleId = data.moduleId;
            const toc = data.toc;
            const map = {};
            const nameMap = {};
            const fileMap = {};
            let maxId = -1;

            // Find the parent lineage of a given toc entry
            function getLineage(tocEntry) {
                const lineage = [];
                let parentId = tocEntry.parentId;

                // Add the current page - useful for breadcrumbs
                lineage.push({
                    name: tocEntry.name,
                    path: tocEntry.path
                });

                // Add parents
                while (parentId > -1) {
                    lineage.push({
                        name: `${map[parentId].name} `,
                        path: map[parentId].vpath
                    });
                    parentId = map[parentId].parentId;
                }

                return lineage.reverse();
            }

            let prevEntry = null;
            // Construct a map from toc entry id to toc entry
            function constructTOCMap(tocEntry) {
                // Cache the largest toc entry id - used later in navigation
                // constuction
                if (tocEntry.id > maxId) maxId = tocEntry.id;

                // NOTE: Page map key values need to be lower case as intra-
                // module links come through as lower case.
                nameMap[tocEntry.name.toLowerCase().trim()] = tocEntry.path;
                // NOTE: File name map values are not case sensitive
                fileMap[tocEntry.path] = tocEntry.name;

                const lineage = getLineage(tocEntry);

                navigation[tocEntry.path] = {
                    lineage,
                    path: tocEntry.path,
                    previous: prevEntry ? prevEntry.path : '',
                    next: ''
                };
                if (prevEntry) navigation[prevEntry.path].next = tocEntry.path;
                prevEntry = tocEntry;

                if (tocEntry.children && tocEntry.children.length > 0) {
                    map[tocEntry.id] = tocEntry;

                    tocEntry.children.forEach((child) => {
                        constructTOCMap(child);
                    });
                }
                /* Skip parent method
                if (!(tocEntry.children && tocEntry.children.length > 0)) {
                    // Cache the largest toc entry id - used later in navigation
                    // constuction
                    if (tocEntry.id > maxId) maxId = tocEntry.id;

                    // NOTE: Page map key values need to be lower case as intra-
                    // module links come through as lower case.
                    nameMap[tocEntry.name.toLowerCase().trim()] = tocEntry.path;
                    // NOTE: File name map values are not case sensitive
                    fileMap[tocEntry.path] = tocEntry.name;

                    const lineage = getLineage(tocEntry);

                    navigation[tocEntry.path] = {
                        lineage,
                        path: tocEntry.path,
                        previous: prevEntry ? prevEntry.path : '',
                        next: ''
                    };
                    if (prevEntry) navigation[prevEntry.path].next = tocEntry.path;
                    prevEntry = tocEntry;
                } else {
                    map[tocEntry.id] = tocEntry;

                    tocEntry.children.forEach((child) => {
                        constructTOCMap(child);
                    });
                }
                */
            }

            if (toc) constructTOCMap(toc);

            Vue.set(state.navigation, moduleId, navigation);
            Vue.set(state.pageNameMap, moduleId, nameMap);
            Vue.set(state.fileNameMap, moduleId, fileMap);
        });
    },

    [types.SET_CURRENT_PAGE](state, page) {
        state.currentPage = page;
    }
    /* eslint-enable no-param-reassign */
};



// WEBPACK FOOTER //
// ./src/store/modules/navigation/mutations.js